<template>
  <div>
    <div class="flex cursor-pointer" @click="isOpen = !isOpen">
      <a :class="item.active ? 'active' : ''" :href="item.value" class="text-14 leading-1.2" :target="item.target">
        <h2>{{ item.name }}</h2>
      </a>
      <button v-if="hasSubMenu" class="align-middle focus:outline-none ml-auto">
        <span class="sr-only">Expand</span>
        <i class="fal fa-fw fa-sm" :class="openIcon"></i>
      </button>
    </div>
    <ul v-if="hasSubMenu" v-show="isOpen" class="border-l border-light-gray p-16 mt-2">
      <li
        v-for="child in subMenuItems"
        class="mb-16 last:mb-0">
        <a :href="child.value"
          class="text-black text-14 leading-1.2"
          :target="child.target">
          <h3>{{ child.name }}</h3>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    open: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      menu: jsonFromPage('#data-navbar-menu'),
      isOpen: this.open,
    }
  },

  computed: {
    hasSubMenu () {
      return this.itemChildren.length > 0
    },

    openIcon () {
      return this.isOpen ? 'fa-chevron-down' : 'fa-chevron-right'
    },

    itemChildren () {
      return this.item.children.filter(child => child.enabled)
    },

    subMenuItems () {
      return this.itemChildren.find(item => item.children.filter(child => child.enabled).length > 0)?.children ||
        this.itemChildren
    },
  },

  created() {
    this.urlChecker(this.item)
  },

  methods: {
    urlChecker(item) {
      if (item.value.endsWith(window.location.pathname)) {
        this.$set(item, 'active', true)
      } else {
        this.$set(item, 'active', false)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.active {
  color: #ff6700;
  font-weight: 600;
}
</style>
